<template>
  <div>
    <filter-card :get-report="getReports" />
    <div
      v-if="loading"
      class="mb-1 py-2 bg-light-primary rounded"
    >
      <pre-loading />
    </div>
    <template v-else>
      <incomes-monthly />
      <expenses-monthly />
      <incomes-yearly />
      <expenses-yearly />
      <banks-report />
      <safes-report />
      <promissories-report />
      <sadaka-list-report />
      <zekat-list-report />
    </template>
  </div>
</template>
<script>
import PreLoading from '@/layouts/components/common/PreLoading.vue'
import FilterCard from '@/views/Admin/Reports/Director/Components/FilterCard.vue'
import IncomesMonthly from '@/views/Admin/Reports/Director/Components/IncomesMonthly.vue'
import ExpensesMonthly from '@/views/Admin/Reports/Director/Components/ExpensesMonthly.vue'
import IncomesYearly from '@/views/Admin/Reports/Director/Components/IncomesYearly.vue'
import ExpensesYearly from '@/views/Admin/Reports/Director/Components/ExpensesYearly.vue'
import BanksReport from '@/views/Admin/Reports/Director/Components/BanksReport.vue'
import SafesReport from '@/views/Admin/Reports/Director/Components/SafesReport.vue'
import PromissoriesReport from '@/views/Admin/Reports/Director/Components/PromissoriesReport.vue'
import SadakaListReport from '@/views/Admin/Reports/Director/Components/SadakaListReport.vue'
import ZekatListReport from '@/views/Admin/Reports/Director/Components/ZekatListReport.vue'

export default {
  name: 'DirectorIndex',
  components: {
    PreLoading,
    FilterCard,
    IncomesMonthly,
    ExpensesMonthly,
    IncomesYearly,
    ExpensesYearly,
    BanksReport,
    SafesReport,
    PromissoriesReport,
    SadakaListReport,
    ZekatListReport,
  },
  computed: {
    loading() {
      return this.$store.getters['directorReports/loading']
    },
    year() {
      return this.$store.getters['directorReports/year']
    },
    zekatList() {
      return this.$store.getters['directorReports/zekatList']
    },
    filterParams() {
      return this.$store.getters['directorReports/filterParams']
    },
  },
  created() {
    this.getReports()
  },
  methods: {
    getReports() {
      this.$store.dispatch('directorReports/getReport', {
        sdate: this.filterParams.sdate,
        edate: this.filterParams.edate,
        year: this.filterParams.year,
      })
    },
  },
}
</script>
